import { render, staticRenderFns } from "./RegisterStep12.vue?vue&type=template&id=200eeb61&"
import script from "./RegisterStep12.vue?vue&type=script&lang=js&"
export * from "./RegisterStep12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports